exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3revO{overflow-y:scroll;height:100%}._1GsW5{line-height:20px;font-size:15px;font-weight:400;padding:20px 0 20px 25px;cursor:pointer;color:#595959}body.reader-night-mode ._1GsW5{color:#b3b3b3}._1GsW5:hover{color:#262626}body.reader-night-mode ._1GsW5:hover{color:#fff}._1GsW5 .fa{padding-right:3px;font-size:18px;vertical-align:bottom}._2cVn3{line-height:30px;padding:20px 0 20px 25px;cursor:pointer;color:#999;margin-bottom:80px}body.reader-night-mode ._2cVn3{color:#b3b3b3}._2cVn3:hover{color:#666}body.reader-night-mode ._2cVn3:hover{color:#fff}", ""]);

// exports
exports.locals = {
	"sort-wrapper": "_3revO",
	"new-note-top": "_1GsW5",
	"new-note-bottom": "_2cVn3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/NotesWrapper/NotesWrapper.scss
// module id = xyOF
// module chunks = 3